import { Component, OnInit } from "@angular/core";
import { JurorService } from "../../services/juror.service";
import { ToastrService } from "ngx-toastr";
import { BsModalService } from "ngx-bootstrap";
import { Juror } from "../../interfaces/juror";
import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ReCaptcha2Component } from "ngx-captcha";
import { MessageService } from "../../services/message.service";
import { LanguagesService } from "src/app/services/languages.service";

@Component({
  selector: "app-token-confirmation",
  templateUrl: "./token-confirmation.component.html",
  styles: []
})
export class TokenConfirmationComponent implements OnInit {
  model = {
    idUtente: null,
    token: null,
    ignoreCaptcha: false,
    captchaResponse: null
  };

  jurorLite = {
    idJuror: null,
    nome: null,
    cognome: null,
    siteKey: null
  };

  tokenValidated = false;

  form = new FormGroup({});

  options: FormlyFormOptions = {};

  greeting: string;

  private googlereCaptcha: ReCaptcha2Component;

  fields: FormlyFieldConfig[];
  createFields() {
    this.fields = [
      {
        fieldGroupClassName: "row justify-content-center",
        fieldGroup: [
          {
            className: "col-md-6 align-self-center",
            key: "token",
            type: "sanremo-input-lite",
            focus: true,
            templateOptions: {
              label: this.languageService.getValue('insert_token_message'),
              required: true
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            }
          },
          {
            className: "col-md-4",

            key: "recaptcha",
            type: "sanremo-recaptcha",
            templateOptions: {
              siteKey: this.jurorLite.siteKey,
              // required: true,
              callback: (event: ReCaptcha2Component, valid: boolean) => {
                this.googlereCaptcha = event;
                this.model.ignoreCaptcha = !valid;
              }
            },
            expressionProperties: {
              "templateOptions.required": "!model.ignoreCaptcha"
            },
            validation: {
              messages: {
                required: this.languageService.getValue('campo_obbligatorio')
              }
            },
            wrappers: ["form-field"]
          }
        ]
      }
    ];
  }

  constructor(
    private jurorService: JurorService,
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private messageService: MessageService,
    private languageService: LanguagesService,
  ) {}

  ngOnInit() {
    this.messageService.reportMessage("Confirm Token Code");
    this.model.idUtente = this.activeRoute.snapshot.params["userId"];
    this.jurorService
      .getInfoJurato(this.model.idUtente)
      .subscribe(jurorLite => {
        if (jurorLite.esito !== 0) {
          this.jurorLite = null;
        } else {
          this.jurorLite = jurorLite;
          this.greeting = `${this.languageService.getValue('greeting')} ${jurorLite.nome} ${jurorLite.cognome}`;
          this.createFields();
        }
      });
  }

  save() {
    let response = this.googlereCaptcha.getResponse();
    if (!this.form.valid || !response) {
      this.toastrService.error('', this.languageService.getValue('errore_form'), {
				disableTimeOut: true
			});

      return;
    }
    this.model.captchaResponse = response;
    this.jurorService.checkToken(this.model).subscribe(response => {

      if (response.esito == 0) {
        this.router.navigateByUrl("/token-confirmed");
      } else {
        this.toastrService.error(null, response.descrizione, {
          disableTimeOut: true
        });
        this.googlereCaptcha.reCaptchaApi.reset();
        this.form.get("recaptcha").reset();
      }
    });
  }

}
